
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useLiveAnalytics = () => {
  const [liveData, setLiveData] = useState<{ presences: any[] }>({ presences: [] });

  useEffect(() => {
    let channel: any = null;

    const setupAnalytics = async () => {
      try {
        const channelName = 'gamehub-live-activity';
        channel = supabase.channel(channelName);

        const onSync = () => {
          try {
            const newState = channel.presenceState();
            const presences = Object.values(newState).flat();
            setLiveData({ presences });
          } catch (error) {
            // Silently handle sync errors
          }
        };

        channel
          .on('presence', { event: 'sync' }, onSync)
          .on('presence', { event: 'join' }, ({ key, newPresences }: any) => {
            onSync();
          })
          .on('presence', { event: 'leave' }, ({ key, leftPresences }: any) => {
            onSync();
          })
          .subscribe((status: string) => {
            if (status === 'SUBSCRIBED') {
              onSync();
            }
          });
      } catch (error) {
        // Silently handle connection errors - don't log for security
      }
    };

    setupAnalytics();

    return () => {
      if (channel) {
        try {
          supabase.removeChannel(channel);
        } catch (error) {
          // Silently handle cleanup errors
        }
      }
    };
  }, []);

  return liveData;
};
